import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InputOtp, InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonComponent } from '../../../../@core/components/ui/button/button.component';
import { AuthenticationService } from '../../../../@core/services/authentication.service';
import { ToastService } from '../../../../@core/services/toast.service';
import { TextCasePipe } from "../../../../@shared/pipes/textCase.pipe";
import { CaseType } from 'src/app/@shared/services/case-format.service';
import { AssetUrlPipe } from "../../../../@shared/pipes/asset-url.pipe";

@Component({
  selector: 'app-verify',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    PasswordModule,
    ButtonComponent,
    InputOtpModule,
    TextCasePipe,
    AssetUrlPipe
  ],
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss'
})
export class VerifyComponent {
  @ViewChild(InputOtp) otpInputRef!: InputOtp;

  otpForm!: FormGroup;

  defaultUrl: string = ''
  returnUrl: string = this.defaultUrl;
  enableSend: boolean = false
  otpValue: string = ''
  timer: number = 29
  enableResend: boolean = false
  email: string = ''

  CASE_TYPE = CaseType;

  domain: string = ''

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastService: ToastService,
    private authenticationService: AuthenticationService
  ) {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.defaultUrl;
    this.domain = this.route.snapshot.queryParams['domain'] ?? '';
  }

  ngOnInit() {
    this.email = this.route.snapshot.paramMap.get('email') ?? '';
    setInterval(() => {
      if (this.timer === 0) {
        this.enableResend = true
      } else {
        this.timer = this.timer - 1
      }
    }, 1000)
  }

  ngOnDestroy() {
    this.timer = 0
  }

  onSubmit() {
    if (this.email && this.otpValue) {
      this.authenticationService.verifyOTP(this.email, this.otpValue).subscribe((res) => {
        if (res.success) {
          this.router.navigate(['/onboard/' + this.email], { queryParams: { domain: this.domain } })
        }
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  otpInput(event: any) {
    this.otpValue = event.value;
    this.enableSend = this.otpValue.length === 6;
  }

  resendOTP() {
    this.authenticationService.sendOTP(this.email).subscribe((res) => {
      if (res.success) {
        this.otpValue = ""
        this.toastService.success(res.message, 'Success!');
        // Reset the timer
        this.timer = 29;
        this.enableResend = false;

        this.otpValue = '';
        this.enableSend = false;

        if (this.otpInputRef) {
          this.otpInputRef.writeValue('');

          const inputElements = document.querySelectorAll('p-inputotp input');
          if (inputElements && inputElements.length) {
            inputElements.forEach((input: Element) => {
              (input as HTMLInputElement).value = '';
            });
          }
        }
      } else {
        this.toastService.error(res.message, 'Error!');
      }
    });
  }
}
